import { useState, useEffect } from "react";

const getIsMobile = (mobileWidthThreshold) => {
  /* c8 ignore next */
  const mobileWidth = mobileWidthThreshold ? mobileWidthThreshold : 769;
  if (typeof window !== "undefined") {
    const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    return width < mobileWidth;
    /* c8 ignore next 3*/
  }
  return false;
};

const getWidth = () => {
  if (typeof window !== "undefined") {
    return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    /* c8 ignore next 3*/
  }
  return 0;
};

export const useDeviceCheck = (mobileWidthThreshold = 769) => {
  const [width, setWidth] = useState(getWidth());
  const [isMobile, setIsMobile] = useState(getIsMobile(mobileWidthThreshold));
  const [screenType, setScreenType] = useState("mobile");

  const onResize = () => {
    setIsMobile(getIsMobile(mobileWidthThreshold));
    setWidth(getWidth());
    if (getWidth() < 1024) {
      setScreenType("mobile");
    } else if (getWidth() >= 1024 && getWidth() < 2048) {
      setScreenType("web");
      /* c8 ignore next 5*/
    } else if (getWidth() >= 2048 && getWidth() < 3008) {
      setScreenType("2k");
    } else {
      setScreenType("4k");
    }
  };

  useEffect(() => {
    window.addEventListener("resize", onResize);

    onResize();

    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, []); //eslint-disable-line

  return { isMobile, width, screenType };
};
